import reduce from 'lodash/reduce';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import isEmpty from 'lodash/isEmpty';
import { findProductLocaleVariants } from 'src/common/utils/product';

export const getFormats = props => {
  const defaultFormats = get(props, 'drawer.defaultFormats.defaultFormats.bookFormats', null);
  const availableFormats = findProductLocaleVariants(props.product.variants, {
    locale: props.productCustomisation.locale
  });
  const availableFormatsId = availableFormats.map(item => item.formatId);
  return props.drawer.items.filter(item => availableFormatsId.includes(item.formatId)).reduce((formats, format) => {
    const gender = kebabCase(format.gender);
    const phototype = kebabCase(format.phototype);
    if (
      (gender === props.productCustomisation.gender || gender === 'all') &&
      (phototype === props.productCustomisation.phototype || phototype === 'all')
    ) {
      const defaultFormat = defaultFormats ? defaultFormats.find(f => f.formatId === format.formatId) : {};

      format = reduce(format, (f, value, key) => {
        if (value) {
          f[key] = value;
        } else if (!isEmpty(defaultFormat) && defaultFormat[key]) {
          f[key] = defaultFormat[key];
        }
        return f;
      }, {});

      return formats.concat(format);
    }
    return formats;
  }, []);
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Formats/helpers.js